import { useConfig } from './useConfig';

export const useNavigate = () => {
	const config = useConfig();

	return config.useNavigate();
};
